"use client";

import { Button } from "@workspace/ui/components";
import Link from "next/link";
import skillsMap from "@/public/animations/1-1.json";
import assignRoleplay from "@/public/animations/1-2.json";
import feedback from "@/public/animations/1-3.json";
import numbersGrow from "@/public/animations/1-4.json";
import { LottieInView } from "@workspace/ui/common";

const ITEMS = [
  {
    title: "Turn Calls into a Live Skills Map",
    animation: {
      type: "lottie",
      data: skillsMap,
    },
    description:
      "Connect Fireflies or Gong in one click. Yolk automatically analyzes your team’s sales calls, scores performance across critical skills, and shows you exactly where deals die, team-wide and by rep.",
    action: {
      name: "Score My Team Now",
      href: "/auth",
    },
  },
  {
    title: "Assign AI Roleplays ",
    animation: {
      type: "lottie",
      data: assignRoleplay,
    },
    description:
      "Yolk auto-builds simulations from real deals. Reps practice the exact scenarios that tripped them up. Your prospects, your objections, your talk tracks – until it sticks.",
    action: {
      name: "Close Your Gaps",
      href: "/auth",
    },
  },
  {
    title: "Actionable Feedback That Sticks ",
    animation: {
      type: "lottie",
      data: feedback,
    },
    description:
      "After each roleplay, reps receive clear, personalized feedback highlighting strengths, weaknesses, and suggested improvements. They know exactly what to adjust before their next real customer call.",
    action: {
      name: "Get Team Insights",
      href: "/auth",
    },
  },
  {
    title: "See Your Numbers Grow",
    animation: {
      type: "lottie",
      data: numbersGrow,
    },
    description:
      "With targeted practice and coaching automation, your reps ramp faster, handle objections confidently, and close more deals. Managers save time while team performance steadily improves.",
    action: {
      name: "Try For Free",
      href: "/auth",
    },
  },
] as const;
export const Overview = () => {
  return (
    <div className="flex flex-col gap-5 w-full items-center">
      {ITEMS.map((item, i) => (
        <div
          key={i}
          style={{ top: i * 20 + 120 }}
          className="sticky flex flex-col items-center rounded-[32px] bg-white border border-[#e3d8c4] p-5 gap-5 w-full max-w-[1144px] lg:flex-row-reverse lg:p-6 lg:pl-12 lg:h-[428px] lg:justify-between lg:overflow-hidden"
        >
          <div className="flex w-full aspect-[67/51] lg:w-[500px] lg:h-[348px] lg:aspect-[unset] rounded-[17px] overflow-hidden bg-[#FFF3DC]">
            {item.animation.type === "lottie" && (
              <LottieInView
                animationData={item.animation.data}
                width={1100}
                height={780}
                loop
              />
            )}
            {/* {item.animation.type === "video" && ( */}
            {/*   <video */}
            {/*     src={item.animation.data} */}
            {/*     width={1100} */}
            {/*     height={780} */}
            {/*     autoPlay */}
            {/*     playsInline */}
            {/*     muted */}
            {/*     loop */}
            {/*   /> */}
            {/* )} */}
          </div>
          <div className="flex flex-col lg:max-w-[428px]">
            <span className="mb-1.5 text-lg font-semibold leading-6 lg:text-[22px]">
              {item.title}
            </span>
            <p className="mb-6 text-sm font-medium text-d-gray lg:text-base">
              {item.description}
            </p>
            <Button
              variant="d-primary"
              asChild
              className="h-12 text-lg font-semibold"
            >
              <Link href={item.action.href}>{item.action.name}</Link>
            </Button>
          </div>
        </div>
      ))}
    </div>
  );
};
